// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".c8dfe079d30b34a7e8b141a6b45f12e3.js";
};